import { render, staticRenderFns } from "./SenderDetails.vue?vue&type=template&id=1567754c&scoped=true&"
import script from "./SenderDetails.vue?vue&type=script&lang=js&"
export * from "./SenderDetails.vue?vue&type=script&lang=js&"
import style0 from "./SenderDetails.vue?vue&type=style&index=0&id=1567754c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1567754c",
  null
  
)

export default component.exports